import { useEffect, useRef, useState } from 'react'
import { padLeftWithZero } from '~/utils'

const minuteSec = 60
const hourSec = 60 * minuteSec
const daySec = 24 * hourSec

export const countdownFormatFn = (duration: number) => {
  const days = ~~(duration / daySec)
  const hours = ~~((duration - days * daySec) / hourSec)
  const minutes = ~~((duration - days * daySec - hours * hourSec) / minuteSec)
  const seconds = ~~(
    duration -
    days * daySec -
    hours * hourSec -
    minutes * minuteSec
  )

  let ret = ''
  if (days !== 0) {
    ret += `${days}天`
  }
  ret += `${padLeftWithZero(hours, 2)}:${padLeftWithZero(
    minutes,
    2
  )}:${padLeftWithZero(seconds, 2)}`

  return ret
}

/**
 * 简化倒计时操作
 * @param deadline 11位的截止时间
 *
 * @return 返回dealline - now
 */
export function useCountdown(deadline: number) {
  const now = Date.now() / 1000
  const [t, setT] = useState(Math.max(~~(deadline - now), 0))

  const intervalRef = useRef(0)
  useEffect(() => {
    window.clearInterval(intervalRef.current)
    intervalRef.current = window.setInterval(() => {
      const now = Date.now() / 1000
      const next = ~~(deadline - now)
      if (next <= 0) {
        window.clearInterval(intervalRef.current)
      }
      setT(Math.max(next, 0))
    }, 1000)

    return () => window.clearInterval(intervalRef.current)
  }, [deadline])

  return t
}

/**
 * 简化倒计时操作
 * @param dur 倒计时秒数
 *
 * @return 返回剩余时间(s)
 */
export function useCountdownDur(dur: number) {
  const [t, setT] = useState(dur)

  const intervalRef = useRef(0)
  useEffect(() => {
    window.clearInterval(intervalRef.current)

    // dur 改变了，重置dur
    setT(dur)

    intervalRef.current = window.setInterval(() => {
      setT(t => {
        const nextT = t - 1
        if (nextT <= 0) {
          window.clearInterval(intervalRef.current)
        }
        return Math.max(nextT, 0)
      })
    }, 1000)

    return () => window.clearInterval(intervalRef.current)
  }, [dur])

  return t
}
